import $ from "jquery";
import _ from "lodash";
import slick from "slick-carousel";
import Rellax from "rellax";

$(".featured-events").slick({
  slidesToShow: 4,
  infinite: false,
  appendArrows: "#featured-events-navigation",
  prevArrow:
    '<span class="slick-prev"><i class="fas fa-arrow-left"></i></span>',
  nextArrow:
    '<span class="slick-next"><i class="fas fa-arrow-right"></i></span>',
  rows: 0,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$(".testimonials").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  appendArrows: "#testimonials-navigation",
  prevArrow:
    '<span class="slick-prev"><i class="fas fa-arrow-left"></i></span>',
  nextArrow:
    '<span class="slick-next"><i class="fas fa-arrow-right"></i></span>',
  dots: false,
  fade: false,
  cssEase: 'ease',
  speed: 500,
});

if (document.querySelectorAll(".rellax").length > 0) {
  let rellax = new Rellax(".rellax", {
    center: true,
  });
}

function logoSwapOut() {
  const pageLogo = document.querySelector("#logo");
  const brandElem = document.querySelector("#brand");

  if (!pageLogo) {
    return false;
  }

  let callback = (entries, observer) => {
    entries.forEach((entry) => {
      console.log(entry.isIntersecting);
      if (!entry.isIntersecting) {
        brandElem.querySelector(".vanity").classList.add("opacity-0");
        brandElem.querySelector(".vanity").classList.remove("opacity-40");
        brandElem.querySelector(".logo").classList.add("opacity-100");
        brandElem.querySelector(".logo").classList.remove("opacity-0");
      } else {
        brandElem.querySelector(".vanity").classList.remove("opacity-0");
        brandElem.querySelector(".vanity").classList.add("opacity-40");
        brandElem.querySelector(".logo").classList.remove("opacity-100");
        brandElem.querySelector(".logo").classList.add("opacity-0");
      }
    });
  };

  let observer = new IntersectionObserver(callback, {});

  observer.observe(pageLogo);
}

logoSwapOut();

$("#menu-open").click(function () {
  $("#mobile-menu-content").addClass("is-open");
  $("body").addClass("nav-is-open");
});

$("#menu-close").click(function () {
  $("#mobile-menu-content").removeClass("is-open");
  $("body").removeClass("nav-is-open");
});

$("*[data-lightbox]").click(function () {
  event.preventDefault();

  let target = $("#" + $(this).data("lightbox"));

  target.addClass("is-open");
  $("body").addClass("lightbox-is-open");
});

$(".lightbox").click(function () {
  if (!$(this).hasClass("is-open")) {
    return;
  }

  $(this).removeClass("is-open");
  $("body").removeClass("lightbox-is-open");
});
